<template>
    <modal id="candidate-note-modal"
           size="large"
           v-model="showModal"
           :title="title"
           @submit="submit"
           :loading="loading"
           :preloader="preloader">

        <form :data-url="apiUrl.CANDIDATE_NOTES"
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">

            <!-- Note Field -->
            <app-form-group
                :label="$t('note')"
                type="textarea"
                :text-area-rows="4"
                v-model="formData.note"
                :placeholder="$placeholder('note')"
                :required="true"
                :error-message="$errorMessage(errors, 'note')"
            />

            <!-- Hidden Candidate ID Field -->
            <input type="hidden" v-model="formData.candidate_id" />

        </form>
    </modal>
</template>


<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";

export default {
    name: "CandidateNoteCreate",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        candidateId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            formData: {
                note: '',
                candidate_id: '',
            },
            title: "Add Candidate Note",
            loading: false,
            errors: {},
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = { ...this.formData };

            // Prepare the form data to be sent with the POST request
            formData = formDataAssigner(new FormData, formData);
            formData.append('candidate_id', this.candidateId);
            let url = `${this.apiUrl.CANDIDATNOTE}/${this.candidateId}/notes`;

            axiosPost(url, formData).then(({ data }) => {
                this.loading = false;
                $('#candidate-note-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;  // Close the modal
                this.toastAndReload(data.message, 'candidate-table'); // Optionally, reload a table
                setTimeout(function() {
                    window.location.reload();
                }, 1000);
            }).catch(({ response }) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#candidate-note-modal').modal('hide');
            this.toastAndReload(data.message, 'candidate-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    },
};
</script>

